module.exports = __webpack_public_path__ + "img/artillery.35de0cb2.png";